module.exports = __webpack_public_path__ + "static/media/all_panoramatic.532cc626.jpg";